/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class ModalUpgradePanel extends React.Component {
    render() {
        return (
            <div className="post-modal-config panel upgrade-panel">
                <div className="dismiss-panel" onClick={this.props.activateAccessory} data-accessory={this.props.panelName} role="button" aria-label='close'>
                    <i className="ion-arrow-down-a"></i>
                </div>
                <div className="upgrade-headline">
                    {this.props.headline}
                </div>
                <div className="upgrade-subhead">
                    {this.props.subhead}
                </div>
                <div className="modal-upgrade-button">
                    <button className="btn-primary fixed modal-upgrade" onClick={this.props.onClick}>
                        {this.props.actionLabel}
                    </button>
                </div>
            </div>
        );
    }
};

ModalUpgradePanel.displayName = "ModalUpgradePanel";

ModalUpgradePanel.propTypes = {
    headline: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    subhead: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    actionLabel: PropTypes.string,
    onClick: PropTypes.func
};

ModalUpgradePanel.defaultProps = {
    headline: '',
    subhead: '',
    actionLabel: '',
    onClick: () => {}
};

export default ModalUpgradePanel;
